import { Record } from 'immutable';
import { OBJECT_PROPERTY } from 'automation-ui-flow-core/fields/PropertyValueTypes';
import * as DateMetadataKeys from 'automation-ui-action-features/time/DateMetadataKeys';
export default class PropertyDate extends Record({
  [DateMetadataKeys.TYPE]: OBJECT_PROPERTY,
  [DateMetadataKeys.PROPERTY_NAME]: null
}, 'PropertyDate') {
  getType() {
    return this.get(DateMetadataKeys.TYPE);
  }
  getPropertyName() {
    return this.get(DateMetadataKeys.PROPERTY_NAME);
  }
  setPropertyName(propertyName) {
    return this.set(DateMetadataKeys.PROPERTY_NAME, propertyName);
  }
}